import { DOMParser } from "xmldom";
import httpService from "../services/http.service";
import { getBillingApiRoute } from "./api.utils";

export function divideIntoSubarrays(arr, numSubarrays = 4) {
  try {
    const subarrays = Array.from({ length: numSubarrays }, () => []); // Create empty subarrays

    arr.forEach((item, index) => {
      subarrays[index % numSubarrays].push(item); // Distribute items round-robin
    });

    return subarrays;
  } catch (error) {
    console.log(arr);
    return [];
  }
}

export function parseVastXML(vastXml) {
  try {
    const parser = new DOMParser();
    const doc = parser.parseFromString(vastXml, "text/xml");
    // Get the creatives
    const creatives = doc.getElementsByTagName("Creative");
    const creativesInfo = [];

    for (let i = 0; i < creatives.length; i++) {
      const creative = creatives[i];
      const creativeId = creative.getAttribute("id");
      const creativeSlot = creative.getAttribute("creative-slot");
      const creativeCapacity = +creative.getAttribute("ext-capacity");
      const creativeRandomMedia = Boolean(
        creative.getAttribute("ext-random-media")
      );

      const linear = creative.getElementsByTagName("Linear")[0];
      const duration =
        linear?.getElementsByTagName("Duration")[0]?.textContent || null;

      const mediaFiles = linear?.getElementsByTagName("MediaFile");
      const mediaUrls = [];

      for (let j = 0; j < mediaFiles?.length; j++) {
        mediaUrls.push(mediaFiles[j]?.textContent);
      }

      const clickthrough =
        linear?.getElementsByTagName("ClickThrough")[0]?.textContent || null;
      const clickTracking =
        linear?.getElementsByTagName("ClickTracking")[0]?.textContent || null;

      const trackingEvents = {};
      const trackingNodes = linear?.getElementsByTagName("Tracking");

      for (let k = 0; k < trackingNodes?.length; k++) {
        const event = trackingNodes[k]?.getAttribute("event");
        const eventUrl = trackingNodes[k]?.textContent;
        trackingEvents[event] = eventUrl;
      }

      creativesInfo.push({
        creativeId,
        creativeCapacity,
        creativeRandomMedia,
        creativeSlot,
        duration,
        mediaUrls,
        clickthrough,
        clickTracking,
        trackingEvents,
      });
    }

    return {
      preRoll: creativesInfo.find((x) => x.creativeSlot === "pre-roll") || {},
      firstQuartile:
        creativesInfo.find((x) => x.creativeSlot === "first-quartile") || {},
      midRoll: creativesInfo.find((x) => x.creativeSlot === "mid-roll") || {},
      thirdQuartile:
        creativesInfo.find((x) => x.creativeSlot === "third-quartile") || {},
    };
  } catch (error) {
    console.log(`VAST Parsing Error: ${error}`);
    return null;
  }
}

export const getUserSubscriptionStatus = async () => {
  try {
    const response = await httpService.get(getBillingApiRoute("payment"), {
      params: {
        pageIndex: 10,
        pageNumber: 1,
        status: 1,
        orderType: "subscription",
      },
    });
    const { data } = response;

    const activeItem = data?.data?.results.find(
      (item) =>
        item.status === 1 &&
        item.subscriptionInfo &&
        new Date(item.subscriptionInfo.expireDate) > new Date()
    );

    if (!activeItem) {
      return 0;
    }

    const currentDate = new Date();
    const expireDate = new Date(activeItem.subscriptionInfo.expireDate);
    const timeDiff = expireDate - currentDate;
    const daysDiff = Math.round(timeDiff / (1000 * 60 * 60 * 24));

    return daysDiff;
  } catch (err) {
    console.log("Payment Status get error", err);
    return 0;
  }
};

export function base64EncodeWithoutPadding(input) {
  const base64 = btoa(input);
  return base64.replace(/=+$/, ""); // Remove trailing '=' characters
}

export function base64DecodeWithoutPadding(base64) {
  const paddedBase64 = base64.padEnd(
    base64?.length + ((4 - (base64?.length % 4)) % 4),
    "="
  );
  return atob(paddedBase64);
}

export const getContentTypeName = (kind) => {
  if (!kind) return null;

  if (kind === "movie") {
    return `فیلم`;
  } else if (kind === "animation") {
    return `انیمیشن`;
  } else if (kind === "music") {
    return `موسیقی`;
  } else if (kind === "sport") {
    return `برنامه ورزشی`;
  } else if (kind === "program") {
    return `برنامه`;
  } else if (kind === "series") {
    return `سریال`;
  }
};
